export const validateName = (name) => {
    if (!name?.trim()) {
        return "Name is required";
    }

    const nameRegex = /^[A-Za-z\s]+$/;

    if (!nameRegex.test(name.trim())) {
        return "Name should contain only letters";
    }

    return "";
};

export const validateEmail = (email) => {
    if (!email?.trim()) {
        return "Email is required";
    }

    const emailRegex =
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email.trim())) {
        return "Enter a valid email address";
    }

    return "";
};

// export const validatePhone = (phone, countryCode) => {
//     if (!phone?.trim()) {
//         return "Mobile number is required";
//     }

//     if (!/^\d+$/.test(phone)) {
//         return "Only numbers are allowed";
//     }

//     const requiredLength =
//         countryCode === "+91" ? 10 : 7;

//     if (phone.length !== requiredLength) {
//         return countryCode === "+91"
//             ? "Enter valid 10 digit mobile number"
//             : "Enter valid 7 digit mobile number";
//     }

//     return "";
// };

export const validatePhone = (phone) => {
    if (!phone?.trim()) {
        return "Mobile number is required";
    }

    if (!/^\d+$/.test(phone)) {
        return "Only numbers are allowed";
    }

    if (phone.length !== 9) {
        return "Enter valid 9 digit mobile number";
    }

    return "";
};